import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSecurityCompanyDetail,
  getSecurityCompanyDetail,
  getSecurityCompanyId,
  getSecurityCompanySubscriptions,
} from 'reducers/securityCompany';
import { transformSubscriptions } from 'utils/DataTransform/SecurityCompanies/subscriptions';
import BasePanel from 'containers/Base/BasePanel';

import { subscriptionColumns } from './options';

const Products = () => {
  const subscribedProducts = useSelector(state =>
    getSecurityCompanySubscriptions(state),
  );
  const details = useSelector(state => getSecurityCompanyDetail(state));
  const paymentType = details?.billingInfo?.paymentMethod?.last4;
  const companyId = useSelector(state => getSecurityCompanyId(state));
  const updateSubscriptions = useDispatch(dispatch =>
    dispatch(id => fetchSecurityCompanyDetail(id)),
  );
  const transformedData = transformSubscriptions(
    subscribedProducts,
    paymentType,
  );

  const [subsGridApi, setSubsGridApi] = useState();

  const onUpdate = () => {
    updateSubscriptions(companyId);
  };

  const cancelSubscription = () => {
    subsGridApi.deselectAll();
  };
  return (
    <BasePanel
      header="Subscriptions"
      fitColumnsToSize
      cols={subscriptionColumns}
      data={transformedData}
      onUpdate={onUpdate}
      rowModelType="infinite"
      pagination={true}
      enhancedCancellation={cancelSubscription}
      setGridAPI={setSubsGridApi}
      totalEntries={transformedData.length}
    />
  );
};

export default Products;
